import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import { ArrowRight } from 'lucide-react';

export default function CtaFooter({ onConnect }) {
  const { t } = useI18n();
  return (
    <>
      <section style={{ position: 'relative', padding: '48px 24px', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(760px 340px at 50% 0%, rgba(59,116,255,0.18), transparent 66%), radial-gradient(500px 260px at 50% 0%, color-mix(in srgb, var(--hm-gold) 14%, transparent), transparent 66%)', pointerEvents: 'none' }} />
        <div style={{ position: 'relative', maxWidth: 760, margin: '0 auto', textAlign: 'center' }}>
          <h2 className="font-sora" style={{ margin: 0, fontSize: 'clamp(30px, 5vw, 54px)', fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1.05 }}>{t.cta.title}</h2>
          <p style={{ margin: '16px auto 0', maxWidth: '46ch', fontSize: 16.5, lineHeight: 1.6, color: 'var(--color-neutral-400)' }}>{t.cta.text}</p>
          <button onClick={onConnect} className="btn-gold" style={{ marginTop: 30, padding: '15px 30px', borderRadius: 12, fontSize: 16, display: 'inline-flex', alignItems: 'center', gap: 8 }}>{t.cta.button} <ArrowRight size={17} /></button>
          <div style={{ marginTop: 12, fontSize: 12.5, color: 'var(--color-neutral-600)' }}>{t.cta.note}</div>
        </div>
      </section>
      <footer style={{ padding: '40px 24px' }}>
        <div style={{ maxWidth: 1160, margin: '0 auto', display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', justifyContent: 'space-between', gap: 24 }}>
          <div>
            <img src="/assets/hitmax_new.webp" alt="HITMAX" draggable={false} style={{ height: 40, width: 'auto', display: 'block', userSelect: 'none' }} />
            <p style={{ margin: '12px 0 0', fontSize: 12.5, color: 'var(--color-neutral-600)', maxWidth: '44ch', lineHeight: 1.5 }}>{t.footer.tagline}</p>
          </div>
          <div style={{ display: 'flex', gap: 26, fontSize: 13, color: 'var(--color-neutral-500)', flexWrap: 'wrap' }}>
            <a href="#match" style={{ color: 'inherit' }}>{t.nav.analyses}</a>
            <a href="#features" style={{ color: 'inherit' }}>{t.nav.features}</a>
            <a href="#avis" style={{ color: 'inherit' }}>{t.nav.reviews}</a>
            <a href="#faq" style={{ color: 'inherit' }}>{t.nav.faq}</a>
          </div>
        </div>
        <div style={{ maxWidth: 1160, margin: '24px auto 0', paddingTop: 20, borderTop: '1px solid var(--color-divider)', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 14 }}>
          <span style={{ fontSize: 12, color: 'var(--color-neutral-700)' }}>{t.footer.copyright}</span>
          <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
            <Link to="/confidentialite" data-testid="footer-confidentialite" style={{ fontSize: 12.5, color: 'var(--color-neutral-500)', textDecoration: 'none' }}>{t.pages.confidentialite}</Link>
            <Link to="/support" data-testid="footer-support" style={{ fontSize: 12.5, color: 'var(--color-neutral-500)', textDecoration: 'none' }}>{t.pages.support}</Link>
            <Link to="/mentions-legales" data-testid="footer-mentions" style={{ fontSize: 12.5, color: 'var(--color-neutral-500)', textDecoration: 'none' }}>{t.pages.mentions}</Link>
          </div>
        </div>
      </footer>
    </>
  );
}
